var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insights content-wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container",class:_vm.selectedMenu},[(_vm.menuSelected('reports') && _vm.hasInsightsRights())?_c('reports',{attrs:{"id":"reports-insights"}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }